import React, { useEffect, useState } from 'react';
import { useProductsContext } from '../../contexts/ProductsContext';
import { Product } from '../../types';
import { ProductOfferProps } from './ProductOfferProps';
import SharedLastUpsellOfferItem from './SharedLastUpsellOfferItem';

export const SharedLastUpsellCandyCartProductOffer = ({
  offer,
  currency,
  handleAddToCart,
  handleRemoveFromCart,
  indexInOffers,
  offerCount,
  currentProduct,
  onReady,
}: ProductOfferProps) => {
  const { loadProduct } = useProductsContext();
  const [products, setProducts] = useState<Product[]>([]);

  useEffect(() => {
    const loadProducts = async () => {
      if (offer.items?.length > 0) {
        const promises = Array.from(
          offer.items.map((item) => loadProduct(item.item_handle)),
        );
        // A different approach of setting each product after resolving it didn't make a real difference
        // in the behaviour, though we increased complexity. Because of that the simultaneous promise resolving
        // was chosen because of its simplicity.
        const products = await Promise.all(promises);
        setProducts(products);
      } else if (currentProduct) {
        setProducts([currentProduct]);
      }
    };
    void loadProducts();
  }, [currentProduct, loadProduct, offer.items]);

  useEffect(() => {
    if (onReady && products) {
      onReady();
    }
  }, [onReady, products]);

  if (!loadProduct || !products) {
    return null;
  }

  return (
    <>
      {products
        // filtering undefined/empty products so that not everything breaks.
        // Currently its just for safety, theoretically this shouldn't happen
        .filter((product) => product)
        .map((product) => {
          return (
            <SharedLastUpsellOfferItem
              key={product.id}
              offer={offer}
              currency={currency}
              handleAddToCart={handleAddToCart}
              handleRemoveFromCart={handleRemoveFromCart}
              offerCount={offerCount}
              indexInOffers={indexInOffers}
              product={product}
            />
          );
        })}
    </>
  );
};

export default SharedLastUpsellCandyCartProductOffer;
